var settings = {
    errorElement: "span",
    submitHandler: function (form) {
        showLoading();
        form.submit();
    }
};

$.validator.unobtrusive.options = settings;

// This method adds a new rule called 'filesize' along with a message to the options.
$.validator.unobtrusive.adapters.add('filesize', ['maxfilesize'], function (options) {

    // set the parameter
    options.rules['filesize'] = options.params.maxfilesize;

    if (options.message) {
        // If there is a message, set it for the rule
        options.messages['filesize'] = options.message;
    }
});


// Register custom addapter for the acceptedextensions
$.validator.unobtrusive.adapters.add('acceptedextensions', ['acceptedextensions'], function (options) {

    // Set up test parameters
    var accepted = [];

    $.each(options.params.acceptedextensions.split(","), function () {
        accepted.push($.trim(this));
    });

    // Match parameters to the method to execute
    options.rules['acceptedextensions'] = accepted;

    if (options.message) {
        // If there is a message, set it for the rule
        options.messages['acceptedextensions'] = options.message;
    }
});
